import { render, staticRenderFns } from "./SkillCard.vue?vue&type=template&id=22b8fc06&lang=html"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"
import style0 from "./SkillCard.vue?vue&type=style&index=0&id=22b8fc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports